import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { autodeskHubLoad } from 'portal/store/integrations/autodesk/actions'

export const useAutodeskProjectsLoader = (hubId: string) => {
  const dispatch = useDispatch()

  const reload = useCallback(
    (hubId: string) => {
      if (hubId) {
        dispatch(autodeskHubLoad(hubId))
      }
    },
    [dispatch]
  )

  useEffect(() => {
    reload(hubId)
  }, [reload, hubId])

  const { loading, error, data } = useSelector((state: any) => {
    return state.integrationAutodeskHub
  })

  return {
    loading,
    error,
    data,
    reload
  }
}
